import React, { Fragment, memo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DateTimePicker } from '@mantine/dates';
import {
    Button,
    ButtonGroup,
    ButtonToolbar,
    Col,
    Form,
    Image,
    Row,
} from 'react-bootstrap';
import DatePicker from 'react-date-picker';

import ImageCover from './image_cover';
import { DATETIME_FORMAT } from '../constants/constants';
import { getCurrentMoscowDate, Range } from '../tools/converters';
import ImageLoader from '../tools/image_loader';
import SelectSearch from '../tools/search_selector';
import TextEditor from '../tools/text_editor';

const spacerStyles = {
    height: 50,
};

export const CheckboxField = memo(({
    name, value, onChange, label, dataAnswer, dataValue, ...restProps
}) => (
    <Form.Check
        {...restProps}
        inline
        type="checkbox"
        id={name}
        name={name}
        checked={value}
        onChange={onChange}
        label={label}
        data-answer={dataAnswer}
        data-value={dataValue}
    />
));

export const RadioField = memo((props) => (
    <Form.Check
        type="radio"
        id={props.id}
        name={props.name}
        checked={props.value}
        onChange={props.onChange}
        label={props.label}
    />
));

export const ControlPageBlock = memo((props) => {
    let reject_button = '';

    if (props.onReject) {
        reject_button = (
            <Button variant="outline-warning" onClick={props.onReject}>
                <FontAwesomeIcon icon="paste" />
                {' '}
                На
                доработку
            </Button>
        );
    }

    let cancel_button = '';

    if (props.onCancel) {
        cancel_button = (
            <Button variant="outline-secondary" onClick={props.onCancel}>
                <FontAwesomeIcon icon="redo" />
                {' '}
                Отмена
                {' '}
            </Button>
        );
    }

    let apply_button = '';

    if (props.onApply) {
        apply_button = (
            <Button variant="outline-success" id="apply_button" onClick={props.onApply}>
                <FontAwesomeIcon
                    icon="check"
                />
                {' '}
                Применить
            </Button>
        );
    }

    let remove_button = '';

    const removeHandler = (e) => {
        if (window.confirm(`Внимание! Вы действительно хотите удалить ${props.name || ''}?`)) {
            props.onRemove(e);
        }
    };

    if (props.onRemove) {
        remove_button = (
            <Button variant="outline-danger" onClick={removeHandler}>
                <FontAwesomeIcon icon="trash" />
                {' '}
                Удалить
            </Button>
        );
    }

    return (
        <>
            <br />
            <br />
            <Row>
                <Col md={6} xs={3}>
                    <ButtonToolbar>
                        <ButtonGroup>
                            <Button
                                variant="outline-success"
                                id="save_button"
                                onClick={props.onSave}
                            >
                                <FontAwesomeIcon
                                    icon="save"
                                />
                                {' '}
                                Сохранить
                            </Button>

                            {apply_button}

                            {reject_button}

                            {cancel_button}
                        </ButtonGroup>

                    </ButtonToolbar>
                </Col>

                <Col md={2} xs={2}>
                    <ButtonToolbar>
                        <ButtonGroup>
                            {remove_button}
                        </ButtonGroup>
                    </ButtonToolbar>
                </Col>

            </Row>
            <Row>
                <div style={spacerStyles} />
            </Row>
        </>
    );
});

export const ImageField = memo((props) => {
    let required = '';

    if (props.required) {
        required = '*';
    }

    let style = {};

    if (props.is_not_valid) {
        style = { backgroundColor: 'pink' };
    }

    return (
        <Form.Group>
            <Form.Label style={style}>{props.label}</Form.Label>
            <span style={{ color: 'red' }}>{required}</span>
            <Image src={props.value} responsive="true" />
            <span className="help-block">{props.restrictions}</span>
            <input
                type="file"
                id={props.name}
                className={props.name}
                // ref={(el) => props.newPic = el}
                onChange={props.onChange}
            />
        </Form.Group>
    );
});

export const ImageLeadField = memo((props) => {
    let required = '';

    if (props.required) {
        required = '*';
    }

    let style = {};

    if (props.is_not_valid) {
        style = { backgroundColor: 'pink' };
    }

    return (
        <Form.Group>
            <Form.Label style={style}><b>{props.label}</b></Form.Label>
            <span style={{ color: 'red' }}>{required}</span>
            {' '}
            <br />
            { props.isWysiCover ? (
                <ImageCover
                    src={props.value}
                    className={props.className}
                    title={props.title}
                    author={props.author}
                />
            ) : (
                <Image
                    src={props.value}
                    fluid
                    className={props.className}
                />
            )}

            <br />

            <span className="help-block">{props.restrictions}</span>

            <ImageLoader
                onChange={props.onChange}
                onRemove={props.onRemove}
                name={props.name}
                title={props.label}
                minSize={props.minSize}
                image={props.value}
                isDefault={props.isDefault}
                isPNG={props.isPNG}
            />

        </Form.Group>
    );
});

export const InputField = memo((props) => {
    let maxlength_str = '';

    if (props.value) {
        const symcount = props.value.length;

        if (props.maxLength) {
            maxlength_str = (`${symcount}/${props.maxLength}`);
        }
    }

    let required = '';

    if (props.required) {
        required = '*';
    }

    let style = {};

    if (props.is_not_valid) {
        style = { backgroundColor: 'pink' };
    }

    if (props.forwardRef && props.forwardRef.current) {
        // props.forwardRef.current.focus();
    }

    const { value } = props;

    const { type } = props;

    function handlePrettyTypography() {
        const { name, value, onChange } = props;

        onChange({
            currentTarget: {
                name,
                id: name,
                value: value.replace(/ - /g, ' — ').replace(/"(.*?)"/g, '«$1»'),
            },
        });
    }

    return (
        <>
            <Form.Label><b>{props.label}</b></Form.Label>
            <span
                style={{ color: 'red' }}
            >
                {required}
            </span>
            {' '}
            {maxlength_str}
            <Form.Control
                id={props.name}
                // autoFocus={!props.noAutoFocus}
                as="input"
                type={type}
                value={value}
                onChange={props.onChange}
                onBlur={handlePrettyTypography}
                readOnly={props.readOnly}
                maxLength={props.maxLength || 255}
                placeholder={props.placeholder || ''}
                ref={props.forwardRef}
                style={style}
                autoComplete="off"
                className={props.className}
            />
        </>
    );
});

export const SelectorField = memo((props) => {
    const selector_values = [];

    for (let r = 0; r < props.options.length; r++) {
        selector_values.push(<option
            key={`option_${props.options[r].id}`}
            value={props.options[r].id}
        >
            {props.options[r].name}
        </option>);
    }

    let required = '';

    if (props.required) {
        required = '*';
    }

    let style = {};

    if (props.is_not_valid) {
        style = { backgroundColor: 'pink' };
    }

    return (
        <>
            <Form.Label><b>{props.label}</b></Form.Label>
            <span style={{ color: 'red' }}>{required}</span>
            <Form.Control
                id={props.name}
                value={props.selected || ''}
                as="select"
                placeholder="select"
                onChange={props.onChange}
                readOnly={props.readOnly | false}
                style={style}
            >
                {selector_values}

            </Form.Control>
        </>
    );
});

export const SearchSelectorField = memo((props) => {
    let required = '';

    if (props.required) {
        required = '*';
    }

    let style = {};

    if (props.is_not_valid) {
        style = { backgroundColor: 'pink' };
    }

    return (
        <Form.Group>
            <Form.Label><b>{props.label}</b></Form.Label>
            <span style={{ color: 'red' }}>{required}</span>
            <SelectSearch
                isMulti={props.isMulti}
                isAuthors={props.isAuthors}
                id={props.name || props.title}
                name={props.name || props.title}
                req_uri={props.uri}
                default_values={props.value}
                excludes={props.excludes || []}
                onChange={props.onChange}
                searchValue={props.searchValue}
                style={style}
                publishedOnly={props.publishedOnly}
                keepSearchOnClose={props.keepSearchOnClose}
            />
        </Form.Group>
    );
});

export const TextAreaField = memo((props) => {
    let { value } = props;

    if (!value) {
        value = '';
    }

    const symcount = value.length;
    let maxlength_str = '';

    if (props.maxLength) {
        maxlength_str = (`Всего: ${symcount} | Max: ${props.maxLength}`);
    }

    let required = '';

    if (props.required) {
        required = '*';
    }

    let style = {};

    if (props.is_not_valid) {
        style = { backgroundColor: 'pink' };
    }

    const {
        label, name, rows, onChange, ...restProps
    } = props;

    return (
        <Form.Group>

            {label && (
                <>
                    <Form.Label key={name}><b>{label}</b></Form.Label>
                    <span style={{ color: 'red' }}>{required}</span>
                </>
            )}
            <Form.Control
                id={name}
                rows={rows || 5}
                as="textarea"
                value={value}
                onChange={onChange}
                style={style}
                {...restProps}
            />
            {maxlength_str}
            <Form.Control.Feedback />
        </Form.Group>
    );
});

export const TextAreaEditorField = memo((props) => {
    let { value } = props;

    if (!value) {
        value = '';
    }

    const symcount = value.length;
    let maxlength_str = '';

    if (props.maxLength) {
        maxlength_str = (`Всего: ${symcount} | Max: ${props.maxLength}`);
    }

    let required = '';

    if (props.required) {
        required = '*';
    }

    let style = {};

    if (props.is_not_valid) {
        style = { backgroundColor: 'pink' };
    }

    return (
        <Form.Group>
            <Form.Label><b>{props.label}</b></Form.Label>
            <span style={{ color: 'red' }}>{required}</span>
            <TextEditor
                name={props.name}
                id={props.name}
                descr={value}
                onChange={props.onChange}
                maxLength={props.maxLength || -1}
                rows={props.rows}
                extras={maxlength_str}
                style={style}
                noControls={props.noControls}
                lessControls={props.lessControls}
                isStory={props.isStory}
            />
        </Form.Group>
    );
});

export const DateTimeField = memo((props) => {
    const handleDateChange = (value) => {
        const date = value || getCurrentMoscowDate();

        const formattedRes = `${date.getFullYear()}-${(`0${date.getMonth() + 1}`).slice(-2)
        }-${(`0${date.getDate()}`).slice(-2)}T${(`0${date.getHours()}`).slice(-2)}:${
            (`0${date.getMinutes()}`).slice(-2)}`;

        props.onChange(formattedRes);
    };

    return (
        <Form.Group>
            <DateTimePicker
                label={<b>{props.label}</b>}
                withAsterisk
                value={new Date(props.value) || new Date()}
                onChange={handleDateChange}
                valueFormat={DATETIME_FORMAT}
                clearable
            />
        </Form.Group>
    );
});

export const DateField = memo((props) => {
    let required = '';

    if (props.required) {
        required = '*';
    }

    return (
        <Form.Group>
            <Form.Label><b>{props.label}</b></Form.Label>
            <span style={{ color: 'red' }}>{required}</span>
            <DatePicker
                id={props.name}
                value={new Date(props.value) || new Date()}
                onChange={props.onChange}
                locale="ru-ru"
                showLeadingZeros
            />
        </Form.Group>
    );
});

export const RatingSelectorField = memo((props) => {
    const selector_props = {};
    const rate_steps = [];
    Range(0, 10.5, 0.5).forEach((i) => {
        rate_steps.push({ id: i.toFixed(1), name: i.toFixed(1) });
    });
    Object.assign(selector_props, props);
    selector_props.options = rate_steps;
    selector_props.selected = props.value;

    return (
        <SelectorField {...selector_props} />
    );
});
